import { inject, Injectable, type Signal } from '@angular/core';
import { Store } from '@ngxs/store';
import { LocationState } from '../states/location.state';

@Injectable({ providedIn: 'root' })
export class LocationFacade {
    public readonly timeZones: Signal<Record<string, string> | null>;

    private readonly _store: Store = inject(Store);

    constructor() {
        this.timeZones = this._store.selectSignal(LocationState.timeZones);
    }
}
